import { useEffect } from 'react';
import NavigationMenu from './nav/NavigationMenu';

export default function Navigation({ page, home = false }) {
    // useEffect(function () {
    //     window.initMenu();
    // }, [page])

    if (home) {
        return (
            <div className="navbar-area fixed-top pt-0 bg-transparent">
                <div className="mobile-responsive-nav">
                    <div className="container">
                        <div className="mobile-responsive-menu">
                            <div className="logo">
                                <a href="/" className="home-brand">
                                    <img
                                        src="/assets/images/centrumwandeling_logo.svg"
                                        className="main-logo"
                                        alt="logo"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="desktop-nav bg-transparent">
                    <div className="container">
                        <nav className="navbar navbar-expand-md navbar-light bg-transparent p-0">
                            <a className="navbar-brand home-brand" href="/">
                                <img src="/assets/images/centrumwandeling_logo.svg" className="main-logo" alt="logo" />
                            </a>
                            <div className="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                                <ul className="navbar-nav m-auto d-lg-none">
                                    <NavigationMenu />
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* Start Navbar Area */}
            <div className="navbar-area is-sticky fixed-top">
                <div className="mobile-responsive-nav">
                    <div className="container">
                        <div className="mobile-responsive-menu">
                            <div className="logo">
                                <a href="/">
                                    <img
                                        src="/assets/images/centrumwandeling_logo.svg"
                                        className="main-logo"
                                        alt="logo"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="desktop-nav">
                    <div className="container">
                        <nav className="navbar navbar-expand-md navbar-light">
                            <a className="navbar-brand" href="/">
                                <img src="/assets/images/centrumwandeling_logo.svg" className="main-logo" alt="logo" />
                            </a>
                            <div className="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                                <ul className="navbar-nav m-auto">
                                    <NavigationMenu />
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
            {/* End Navbar Area */}
        </>
    );

    // return (
    //     <>
    //         <div className="header-area sticky-header header-area-left">
    //             <div className="header-layout">
    //                 <div className="logo light">
    //                     <a href="/" className="logo-1">
    //                         <img src="/assets/img/logo/logo.png" alt="logo" />
    //                     </a>
    //                     <a href="/" className="logo-2">
    //                         <img src="/assets/img/logo/logo-2.png" alt="logo" />
    //                     </a>
    //                 </div>
    //             </div>
    //         </div>
    //         <div className="header-area sticky-header header-area-right">
    //             <div className="header-layout">
    //                 <div className="menu-bar">
    //                     <div className="bar-wrap" onClick={toggle}>
    //                         <div className="bar-wrap-open">
    //                             <div className="bar-1" />
    //                             <div className="bar-2" />
    //                             <div className="bar-3" />
    //                         </div>
    //                         <div className="bar-wrap-close">
    //                             <div className="bar-1" />
    //                             <div className="bar-2" />
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //
    //         <div className="header-mobile-area">
    //             <div className="shape" />
    //             <div className="container">
    //                 <div className="row">
    //                     <div className="col-xl-6 col-lg-6 order-2 order-lg-1">
    //                         <div className="menu-info-wrapper">
    //                             <div className="social-icon-wrap">
    //                                 <p>Check onze socials</p>
    //                                 <div className="icon-wrap">
    //                                     <a href={extraFields?.socials_facebook}>
    //                                         <i className="fa-brands fa-facebook-f" />
    //                                     </a>
    //                                     <a href={extraFields?.socials_instagram}>
    //                                         <i className="fa-brands fa-instagram" />
    //                                     </a>
    //                                     <a href={extraFields?.socials_linkedin}>
    //                                         <i className="fa-brands fa-linkedin-in" />
    //                                     </a>
    //                                 </div>
    //                             </div>
    //                             <NieuwsbriefForm />
    //                         </div>
    //                     </div>
    //                     <div className="col-xl-6 col-lg-6 order-1 order-lg-1">
    //                         <div className="main-menu hover-effect">
    //                             <ul>
    //                                 {menu?.map((e, i) => (
    //                                     <li key={i}>
    //                                         <Link to={`/${e.url_titel}`}>{e.titel}</Link>
    //                                     </li>
    //                                 ))}
    //                             </ul>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     </>
    // );
}
